import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretRight, faCaretDown } from '@fortawesome/free-solid-svg-icons'

const handleToggleKeyDown = (onToggle) => (e) => {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault()
    onToggle()
  }
}

const CollapsibleTableSection = ({ title, expanded, onToggle, children }) => (
  <div className="box mb-4 ml-2 mr-2">
    <div
      className="lox-sub-module-sub-panel column is-full is-flex is-justify-content-space-between is-align-items-center has-background-light p-1 mb-0 is-clickable"
      role="button"
      tabIndex={0}
      onClick={onToggle}
      onKeyDown={handleToggleKeyDown(onToggle)}
      aria-expanded={expanded}
    >
      <p className="has-text-dark has-text-weight-bold is-size-6 pl-5">
        <span className="mr-2">
          <FontAwesomeIcon icon={expanded ? faCaretDown : faCaretRight} className="ml-0" />
        </span>
        {title}
      </p>
    </div>

    {expanded && children}
  </div>
)

export default CollapsibleTableSection
